export function nameFormat(database_name) {
    console.log(database_name);
    if (!database_name) {
        return database_name;
    }
    return database_name.replace("/", "_");
}

export const ImageDiv = ({itemName, type, imageUrl}) => {
    if (type === "Single") {
      return <img className="cart-img" src={imageUrl} alt={itemName} />;
    }
    return <img className="cart-img" src={`/assets/products/${itemName}.png`} alt={itemName} />
  }